module.exports = __webpack_public_path__ + "img/astral_17.7acd4a0d.svg";